<template>
  <el-container :style="parent" class="parent">
    <el-row>
      <el-col :span="24" style="margin-bottom:25px;">
        <el-image :src="url"></el-image>
      </el-col>
      <el-col :span="22" :offset="1" v-show="show">
        <el-form ref="datalist" :model="datalist" style="text-align: left;" class="mainform" center>
          <el-form-item label="出库单号:" label-width="85px">
            <div>{{datalist.out_bill_code}}</div>
          </el-form-item>
          <el-form-item label="产品编码:" label-width="85px">
            <div>{{datalist.product_code}}</div>
          </el-form-item>
          <el-form-item label="产品名称:" label-width="85px">
            <div>{{datalist.product_name}}</div>
          </el-form-item>
          <el-form-item label="扫码出库数量:" label-width="115px">
            <div>{{datalist.qty2}}</div>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="22" :offset="1" v-show="!show">
        <h2 style="text-align: center;">
          发货商不存在！
        </h2>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      url: require("../../assets/img/logo.jpg"),
      datalist: {},
      show:false,
      parent: {
        height: "600px"
      }
    };
  },
  mounted() {
    this.getheight();
    this.outbound();
  },
  methods: {
    getheight() {
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    outbound() {
      this.$http
        .get(
          `/api/out/mt/api/scan/selectoutbillorder?freight_bill_code=${this.$route.query.outnum}`
        )
        .then(res => {
          console.log(res.data);
          if (res.data.list.length !== 0) {
            this.datalist = res.data.list[0];
            this.show = true
          }else{
            this.show = false
          }
        });
    }
  }
};
</script>

<style>
</style>